export default function DeleteConfirmIcon({ className }: { className?: string }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="2.5" y="2.5" width="35" height="35" rx="17.5" fill="#FEE4E2" />
      <rect
        x="2.5"
        y="2.5"
        width="35"
        height="35"
        rx="17.5"
        stroke="#FEF3F2"
        strokeWidth="5"
      />
      <path
        d="M23.3333 15V14.3333C23.3333 13.3999 23.3333 12.9332 23.1517 12.5767C22.9919 12.2631 22.7369 12.0081 22.4233 11.8483C22.0668 11.6667 21.6001 11.6667 20.6667 11.6667H19.3333C18.3999 11.6667 17.9332 11.6667 17.5767 11.8483C17.2631 12.0081 17.0081 12.2631 16.8483 12.5767C16.6667 12.9332 16.6667 13.3999 16.6667 14.3333V15M18.3333 19.5833V23.75M21.6667 19.5833V23.75M12.5 15H27.5M25.8333 15V24.3333C25.8333 25.7335 25.8333 26.4335 25.5608 26.9683C25.3212 27.4387 24.9387 27.8212 24.4683 28.0608C23.9335 28.3333 23.2335 28.3333 21.8333 28.3333H18.1667C16.7665 28.3333 16.0665 28.3333 15.5317 28.0608C15.0613 27.8212 14.6788 27.4387 14.4392 26.9683C14.1667 26.4335 14.1667 25.7335 14.1667 24.3333V15"
        stroke="#D92D20"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const displayName = "DeleteConfirmIcon";
